import type { ListItem } from "@airhelp/react";
import config from "config/config";
import { getLocaleFromFullSlug } from "utils/getLocale";
import { isDefaultLanguage } from "utils/isDefaultLanguage";
import type { BuildLanguagesListsParams, BuildLanguagesListsReturnValue } from "./buildLanguagesLists.d";

const buildLanguagesLists = (
  languages: BuildLanguagesListsParams["languages"],
  pageName: BuildLanguagesListsParams["pageName"],
  cmsLanguagesData: BuildLanguagesListsParams["cmsLanguagesData"],
  getPageUrl: BuildLanguagesListsParams["getPageUrl"]
): BuildLanguagesListsReturnValue => {
  const suggestedLanguages: ListItem[] = [];
  const selectLanguages: ListItem[] = [];

  Array.from(languages.entries()).map(([key, { name, languageFlag, popularLanguage, hidden, localDomain }]) => {
    let localizedPagePath = "";

    if (cmsLanguagesData?.length) {
      const cmsPageData = cmsLanguagesData.filter((item) => {
        const locale = getLocaleFromFullSlug(item.full_slug);
        const isParentLanguageSame = locale.split("-")[0] === key.split("-")[0];

        return isDefaultLanguage(locale) ? isParentLanguageSame : locale === key;
      });

      const slug = cmsPageData[0]?.full_slug.split(/\/(.+)?/)[1];
      localizedPagePath = slug ? `/${key}/${slug}` : `/${key}/`;
    } else {
      localizedPagePath = getPageUrl(key, pageName);
    }

    if (hidden) return {};

    const lang = {
      id: key,
      name,
      icon: languageFlag,
      href: localizedPagePath,
    };

    if (localDomain) {
      lang.href = localDomain + lang.href;
    } else {
      lang.href = config.websiteUrl + lang.href;
    }

    return popularLanguage ? suggestedLanguages.push(lang) : selectLanguages.push(lang);
  });

  return {
    suggestedLanguages,
    selectLanguages,
  };
};

export default buildLanguagesLists;
